import React from 'react';
import './HomeProjects.css';
import HomeProjectCard from '../HomeProjectCard/HomeProjectCard';
import './HomeProjects.css';
import useProjectData from '../ProjectData/useProjectData';


const HomeProject = () => {
    const { projectData } = useProjectData()
    return (
        <div id="home-project" className="home-project-main-container">
            <h1 className="home-project-title">Project</h1>
            <div className="home-project-card-container">
                {
                    projectData.map(project => <HomeProjectCard key={project.id} project={project}></HomeProjectCard> )
                }
            </div>
        </div>
    );
};

export default HomeProject;